module.exports = __webpack_public_path__ + "static/img/logo.43cfc46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 1